module.exports = {
    data() {
        return {
            filterText: '',
            defaultSearchItems: window.localStorage.getItem('defaultSearchItems')?.split(',') || [],
            ggList: [],
            pageIndex: 1,
            finished: false,
            canRequest: true,
        }
    },

    methods: {
        async updateList() {
            const { pageIndex, ggList, filterText, canRequest } = this

            if (!canRequest) {
                return
            }

            this.canRequest = false

            let res = {}
            try {
                res = await this.$request.post('/transformToAfter/app/cgxx/search', {
                    pageIndex,
                    pageSize: 10,
                    filter: filterText,
                })
            } catch (e) {
                this.canRequest = true
                return
            }

            const data = res.data
            this.canRequest = true
            this.pageIndex += 1
            this.ggList = pageIndex === 1 ? [...data] : [...ggList, ...data]
            console.info(res, this.ggList.length, res.total, this.ggList.length >= res.total, '=====res===')
            if (this.ggList.length >= res.total) {
                this.finished = true
            } else {
                this.finished = false
            }
        },

        onLoad() {
            if (!this.filterText && this.pageIndex === 1) {
                return
            }
            this.updateList()
        },

        searchItem(data) {
            this.filterText = data
            this.pageIndex = 1
            this.updateList()
        },

        handleClick(data) {
            const common = {
                id: data.id,
                gcGuid: data.gcGuid,
                ggGuid: data.ggGuid,
                bdGuid: data.bdGuid,
            }

            let options = {}
            switch (data.ggLeiXing) {
                case '1':
                    options = {
                        type: 'cgggDetail',
                        title: '招标公告',
                    }
                    break
                case '2':
                    options = {
                        type: 'bgggDetail',
                        title: '变更通知',
                    }
                    break
                case '3':
                    options = {
                        type: 'hxrgsDetail',
                        title: '候选人公示',
                    }
                    break
                case '4':
                    options = {
                        title: '中标结果公示',
                        type: 'zbjgDetail',
                    }
                    break
                case '5':
                    options = {
                        title: '标前公示',
                    }
                    break
                case '6':
                    options = {
                        title: '合同公告',
                    }
                    break
            }

            this.$router.push({
                name: 'NormalDetail',
                query: Object.assign(common, options),
            })
        },

        onSearch(val) {
            const { defaultSearchItems } = this
            const ary = [...new Set([val, ...defaultSearchItems])]

            this.defaultSearchItems = ary.length > 6 ? ary.splice(0, 6) : ary

            window.localStorage.setItem('defaultSearchItems', [...this.defaultSearchItems])
            this.pageIndex = 1
            this.updateList()
        },

        clearHistory() {
            window.localStorage.removeItem('defaultSearchItems')
            this.defaultSearchItems = []
        },

        onCancel() {
            this.$router.go(-1)
        },
    },
}
